import { isEmpty } from 'lodash';
import moment from 'moment-timezone';

const addSeminarStartAndEndDateBySession = (product) => {
  const { seminarInfo } = product;
  // If there's a seminar calculate the start and end date based off of the first and last sessions
  if (!isEmpty(seminarInfo)) {
    const {
      sessions = [],
      timeZone,
    } = seminarInfo;

    const startDates = sessions.map((d) => moment.tz(d.start, timeZone));
    const start = startDates && moment.min(startDates);
    const endDates = sessions.map((d) => moment.tz(d.end, timeZone));
    const end = endDates && moment.max(endDates);

    return {
      ...product,
      seminarInfo: {
        ...product.seminarInfo,
        start,
        end,
      },
    };
  }

  // Otherwise return the product as is
  return product;
};

export default addSeminarStartAndEndDateBySession;
